(() => {
  if (window.InkhavenEventControlIds) return;

  // Result fragments are shared; assign IDs for their destination before insertion.
  window.InkhavenEventControlIds = (card, section, occurrence) => {
    const owner = section.dataset.eventControlScope || section.closest('.shopify-section')?.id;
    if (!owner) return;
    const prefix = `EventControl-${owner}-${card.dataset.eventId}-${occurrence}`;
    const ids = new Map();
    card.querySelectorAll('[data-event-control-id]').forEach((control) => {
      const id = `${prefix}-${control.dataset.eventControlId}`;
      const previousId = control.getAttribute('id');
      if (previousId) ids.set(previousId, id);
      control.setAttribute('id', id);
    });
    card.querySelectorAll('[for], [form], [aria-controls], [aria-labelledby], [aria-describedby]').forEach((element) => {
      ['for', 'form', 'aria-controls', 'aria-labelledby', 'aria-describedby'].forEach((attribute) => {
        if (!element.hasAttribute(attribute)) return;
        const value = element.getAttribute(attribute).split(/\s+/).map((id) => ids.get(id) || id).join(' ');
        element.setAttribute(attribute, value);
      });
    });
  };
})();
